export class AuthenticationError extends Error {
  public error: string;
  public state: string | undefined;

  constructor(error: string, errorDescription: string, state?: string) {
    super(errorDescription);
    this.name = 'AuthenticationError';
    this.error = error;
    this.state = state;
    Object.setPrototypeOf(this, AuthenticationError.prototype);
  }
}
